import React from 'react';
const modules = [{
  num: '1',
  title: 'Delicious Breakfast Recipes to Support Your Energy'
}, {
  num: '2',
  title: 'Flavor-Packed Lunch Recipes to Support Your Metabolism'
}, {
  num: '3',
  title: 'Delicious Dinner Recipes for Everyday Wellness'
}, {
  num: '4',
  title: 'Thyroid-Friendly Smoothies and Nourishing Drinks'
}, {
  num: '5',
  title: 'Energizing Snacks and Mini Meals'
}, {
  num: '6',
  title: "Comfort Foods You'll Actually Enjoy,"
}];
const benefits = ['Knowing exactly what to cook.', 'Having delicious recipes for every part of your day.', 'Spending less time planning meals.', 'Enjoying more variety at breakfast, lunch and dinner.', 'Feeling more organized in the kitchen.', 'Following a simple system throughout the week.'];
export function TomiSection() {
  return <>
      <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-123">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-124">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-text-dark mb-4" data-id="element-125">
            That's Why We Created The Thyroid Reset Cookbook™
          </h2>
          <p className="text-lg text-brand-text-muted mb-3" data-id="element-126">
            The complete system designed for women with hypothyroidism who want
            to enjoy delicious meals while simplifying their daily nutrition.
          </p>
          <div className="space-y-2 text-lg text-brand-text-muted" data-id="element-127">
            <p data-id="element-128">It's not another extreme diet.</p>
            <p data-id="element-129">It's not another boring PDF.</p>
            <p data-id="element-130">It's not another recipe collection you'll never use.</p>
          </div>
          <p className="text-xl font-bold text-brand-forest mt-4" data-id="element-131">
            It's a practical system filled with real recipes for real life.
          </p>
        </div>
      </section>

      <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-132">
        <div className="max-w-3xl mx-auto" data-id="element-133">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-6" data-id="element-134">
            Imagine What Your Week Could Look Like
          </h2>

          <div className="grid sm:grid-cols-2 gap-3 mb-8" data-id="element-135">
            {benefits.map((benefit, i) => <div key={i} className="flex gap-3 items-start bg-white p-4 rounded-lg border border-brand-sage/30" data-id="element-136">
                <span className="text-brand-sage text-xl shrink-0" data-id="element-137">✔</span>
                <p className="text-base text-brand-text-dark" data-id="element-138">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-139">
        <div className="max-w-3xl mx-auto" data-id="element-140">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-6" data-id="element-141">
            Everything Included Inside The Complete 6-in-1 System
          </h2>

          <div className="space-y-4" data-id="element-142">
            {modules.map((module, i) => <div key={i} className="bg-brand-cream border border-brand-sage/30 p-5 rounded-lg" data-id="element-143">
                <div className="flex gap-4 items-center" data-id="element-144">
                  <div className="bg-brand-sage text-white font-bold px-4 py-2 rounded text-sm shrink-0" data-id="element-145">
                    MODULE {module.num}
                  </div>
                  <h3 className="text-lg font-bold text-brand-text-dark" data-id="element-146">
                    {module.title}
                  </h3>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}